import React, {useEffect, useState} from 'react';
import Loader from "../../Loader/Loader";
import {toast} from "react-toastify";
import axios from "axios";
import {Button} from "react-bootstrap";
import './star.css'
import {Rating} from 'react-simple-star-rating'
import callWebService, {callTypes} from "../../service/Networks/network";
import Config from "../../service/Config/config";

const MeetingRating = ({
    id,
    ratingSave = () => {},
    setOpenRatingModel,
    type,
    loadApi = () => {}
}) => {

    const [isLoading, setIsLoading] = useState(false);
    const [projectDetails, setProjectDetails] = useState([])
    const [rating, setRating] = useState(0)
    const [comments, setComments] = useState("");
    const [userId, setUserId] = useState('');

    useEffect(() => {
        if (id) {
            (async () => {
                var config = {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": window.localStorage.token
                    }
                };
                const base_url = process.env.REACT_APP_API_URL;
                const response = await  callWebService(callTypes.get,'',  `${Config?.meetingBtId}?id=${id}`);

                setUserId(window.localStorage.role_id)

                console.log(response)
                if (response?.data?.response?.data) {
                    setProjectDetails(response?.data?.response?.data)
                }
            })()
        }
    }, [id])

    const setRate = (rate) => {
        setRating(rate)
    }
    // Optinal callback functions
    const onPointerEnter = () => console.log('Enter')
    const onPointerLeave = () => console.log('Leave')
    const onPointerMove = (value, index) => console.log(value, index)

    const handleRating = async () => {
        if (rating === 0) {
            toast.warning("Please mark rating")
            return false
        }

        if(type === "HOD" && comments === ""){
            toast.warning("Please enter remark")
            return false
        }

        if(type === "HOD" && comments !== undefined && comments.length < 70){
            toast.warning("Feedback must be minimum 50 characters");
            return false;
        }

        const data = {
            rating_data: {
                rating: rating,
                remark: comments
            },
            id: id,

        }

        setIsLoading(true)
        await ratingSave(data)
        await loadApi(1);
        setIsLoading(false)
    }

    return (
        <>
            <Loader isLoading={isLoading}/>
            <link
                rel="stylesheet"
                href="https://use.fontawesome.com/releases/v5.4.1/css/all.css"
                integrity="sha384-5sAR7xN1Nv6T6+dT2mhtzEpVJvfS3NScPQTrOxhwjIuvcA67KV2R5Jz6kr4abQsz"
                crossOrigin="anonymous"
            />
            <link
                href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,700"
                rel="stylesheet"
            ></link>
            <form className="attForm">
                <div className="row pointer-where-are-you">
                    <div className="row">
                        <div className="col-12">
                            <div className="map">
                                {type !== "HOD" && (
                                    <div className="d-flex">
                                        <p style={{color: '#4e73df'}}><b>Project Name: </b></p>
                                        <p className="kvalue">
                                            {projectDetails?.client_name ? projectDetails?.client_name
                                            : projectDetails?.account_name ? projectDetails?.account_name : projectDetails?.valet_client_name ?projectDetails?.valet_client_name : ""}
                                        </p>
                                    </div>
                                )}

                                {/* <div className="d-flex">
                                    <p style={{color: '#4e73df'}}><b>Conducted By: </b></p>
                                    {projectDetails?.name &&
                                        <p className="kvalue">&nbsp;&nbsp;{projectDetails?.name}</p>
                                    }
                                </div> */}
                                {type !== "HOD" && (
                                    <div className="d-flex">
                                        <p style={{color: '#4e73df'}}><b>Meeting Date: </b></p>
                                        {projectDetails?.activity_date &&
                                            <p className="kvalue">&nbsp;&nbsp; {projectDetails?.activity_date}</p>
                                        }
                                    </div>
                                )}

                                {type !== "HOD" && projectDetails?.module_type && (projectDetails?.module_type === 'Dealer' || projectDetails?.module_type === 'Car Service' || projectDetails?.module_type === 'Fasttag Toll' || projectDetails?.module_type === 'Parking') &&
                                    <div className="d-flex">
                                        <p style={{color: '#4e73df'}}><b>Purpose of visit: </b></p>
                                        {projectDetails?.purpose_of_visit &&
                                            projectDetails?.purpose_of_visit[0] && projectDetails?.purpose_of_visit[0]?.visit_purpose &&
                                            <p className="kvalue">&nbsp;&nbsp;{projectDetails?.purpose_of_visit[0]?.visit_purpose}</p>
                                        }
                                    </div>
                                }
                                {projectDetails?.module_type === 'Valet' &&
                                    <div className="d-flex">
                                        <p style={{color: '#4e73df'}}><b>Purpose of visit: </b></p>
                                        {projectDetails?.meta_data && projectDetails?.meta_data[0] && projectDetails?.meta_data[0]?.payment_collection_details && projectDetails?.meta_data[0]?.payment_collection_details[0] ? (
                                            <p className="kvalue">&nbsp;&nbsp; Payment Collection</p>
                                        ) : projectDetails?.meta_data && projectDetails?.meta_data[0] && projectDetails?.meta_data[0]?.Client_Alignment && projectDetails?.meta_data[0]?.Client_Alignment[0] && projectDetails?.meta_data[0]?.Client_Alignment[0]?.Meeting_Mom ? (
                                            <p className="kvalue">&nbsp;&nbsp; Inspection</p>
                                        ) : projectDetails?.meta_data && projectDetails?.meta_data[0] && projectDetails?.meta_data[0]?.relationship_meeting_details && projectDetails?.meta_data[0]?.relationship_meeting_details[0] && projectDetails?.meta_data[0]?.relationship_meeting_details[0]?.relationship_meeting_mom ? (
                                            <p className="kvalue">&nbsp;&nbsp; Relationship</p>
                                        ) : ""
                                        }
                                    </div>
                                }
                                { type !== "HOD" && projectDetails?.module_type && (projectDetails?.module_type === 'Corporate' || projectDetails?.module_type === 'Apartments') &&
                                    <div className="d-flex">
                                        <p style={{color: '#4e73df'}}><b>Stage: </b></p>
                                        {projectDetails?.stage_name &&
                                            <p className="kvalue">&nbsp;&nbsp; {projectDetails?.stage_name}</p>
                                        }
                                    </div>
                                }
                                { type !== "HOD" && projectDetails?.module_type && (projectDetails?.module_type === 'Corporate' || projectDetails?.module_type === 'Apartments') &&
                                    <div className="d-flex">
                                        <p style={{color: '#4e73df'}}><b>Sub-stage: </b></p>
                                        {projectDetails?.sub_stage_name &&
                                            <p className="kvalue">&nbsp;&nbsp; {projectDetails?.sub_stage_name}</p>
                                        }
                                    </div>
                                }
                                { type !== "HOD" && (
                                    <>
                                        <div className="d-flex">
                                            <p style={{color: '#4e73df'}}><b>MOM: </b></p>
                                            { projectDetails?.meta_data &&  projectDetails?.meta_data[0] && projectDetails?.meta_data[0]?.MOM ? (
                                                <p className="kvalue">&nbsp;&nbsp; {projectDetails?.meta_data[0]?.MOM}</p>
                                            ) : projectDetails?.meta_data &&  projectDetails?.meta_data[0] && projectDetails?.meta_data[0]?.MoM ? (
                                                <p className="kvalue">&nbsp;&nbsp; {projectDetails?.meta_data[0]?.MoM}</p>
                                            ) : projectDetails?.meta_data &&  projectDetails?.meta_data[0] && projectDetails?.meta_data[0]?.remark ? (
                                                <p className="kvalue">&nbsp;&nbsp; {projectDetails?.meta_data[0]?.remark}</p>
                                            ) : projectDetails?.meta_data &&  projectDetails?.meta_data[0] && projectDetails?.meta_data[0]?.Client_Alignment &&
                                            projectDetails?.meta_data[0]?.Client_Alignment[0]&& projectDetails?.meta_data[0]?.Client_Alignment[0]?.Meeting_MoM ? (
                                                <p className="kvalue">&nbsp;&nbsp; {projectDetails?.meta_data[0]?.Client_Alignment[0]?.Meeting_MoM}</p>
                                            ): projectDetails?.meta_data &&  projectDetails?.meta_data[0] && projectDetails?.meta_data[0]?.payment_collection_details && projectDetails?.meta_data[0]?.payment_collection_details[0] && projectDetails?.meta_data[0]?.payment_collection_details[0]?.payment_collection_mom ? (
                                                <p className="kvalue">&nbsp;&nbsp; {projectDetails?.meta_data[0]?.payment_collection_details[0]?.payment_collection_mom
                                                }</p>
                                            ): projectDetails?.meta_data &&  projectDetails?.meta_data[0] && projectDetails?.meta_data[0]?.relationship_meeting_details && projectDetails?.meta_data[0]?.relationship_meeting_details[0] && projectDetails?.meta_data[0]?.relationship_meeting_details[0]?.relationship_meeting_mom ? (
                                                    <p className="kvalue">&nbsp;&nbsp; {projectDetails?.meta_data[0]?.relationship_meeting_details[0]?.relationship_meeting_mom
                                                    }</p>
                                                )
                                                : <p className="kvalue">&nbsp;&nbsp; {projectDetails?.description}</p>
                                            }
                                        </div>
                                    </>
                                )}

                                <div className="rating" data-mdb-toggle="rating">
                                    <Rating
                                        onClick={setRate}
                                        onPointerEnter={onPointerEnter}
                                        onPointerLeave={onPointerLeave}
                                        onPointerMove={onPointerMove}
                                        size={40}
                                        ratingValue={rating}

                                        /* Available Props */
                                    />
                                </div>
                                <div className="col-12">
                                    {type === "HOD" ? (
                                        <>
                                            <textarea
                                                className="form-control form-control-user"
                                                placeholder="Description"
                                                onChange={(e) => {
                                                    setComments(e.target.value);
                                                }}
                                                required={true}
                                                id="validationCustom01"
                                                rows="3"
                                                cols="40"
                                            />
                                        </>
                                    ) : (
                                        <>
                                            <textarea
                                                className="form-control form-control-user"
                                                placeholder="Description"
                                                onChange={(e) => {
                                                    setComments(e.target.value);
                                                }}
                                                id="validationCustom01"
                                                rows="3"
                                                cols="40"
                                            />
                                        </>
                                    )}
                                </div>

                                <div className='row' style={{justifyContent: "center"}}>
                                    <div className="">
                                        <Button className="mr-4" onClick={() => setOpenRatingModel(false)}>
                                            {"Close"}
                                        </Button>
                                        <Button className="" onClick={() => handleRating()}>
                                            {"Submit"}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </>
    )
}

export default MeetingRating